document.documentElement.classList.remove('no-js');

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('.quick-add')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (!button) return;
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Adicionando...';
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Accept':'application/json'},
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Falha ao adicionar');
    button.textContent = '✓ Adicionado';
    const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
    document.querySelectorAll('.cart-link span').forEach(el => el.textContent = cart.item_count);
    setTimeout(() => { button.textContent = original; button.disabled = false; }, 1300);
  } catch (e) {
    button.textContent = 'Tente novamente';
    setTimeout(() => { button.textContent = original; button.disabled = false; }, 1600);
  }
});
